export default "__VITE_ASSET__11eyeEoc__"